// extracted by mini-css-extract-plugin
export default {"contentFooter":"Footer_contentFooter__1Fu5a","footer":"Footer_footer__cOQNQ"};